"use client";
import { useState, useEffect, useMemo } from "react";
import { Slider } from "@heroui/slider";
import Search from "@/public/icon/search.svg";
import React from "react";
import Delete from "@/public/icon/delete.svg";
import Summer from "@/public/icon/sun.svg";
import Snow from "@/public/icon/snow.svg";
import Sun from "@/public/icon/sun1.svg";
import ArrowRight from "@/public/icon/arrowR.svg";
import ArrowLeft from "@/public/icon/arrowLeft.svg";
import Moon from "@/public/icon/moon.svg";
import useClientRouter from "@/hooks/useClientRouter";
import useDebounce from "@/hooks/useDebounce";
const Filter = ({ filter, t }) => {
  const [brandQuery, setBrandQuery] = useState("");
  const [groupQuery, setGroupQuery] = useState("");
  const [authorQuery, setAuthorQuery] = useState("");
  const [noteQuery, setNoteQuery] = useState("");
  const { params, setPropertyToUrl, setPropertyToUrlWithArray } =
    useClientRouter("products");

  const [query, setQuery] = useState("");

  // const [values, setValues] = useState([0, 500]);
  // const [inputValues, setInputValues] = useState([0, 500]);

  const min_value = +params.get("min_price") || 0;
  const max_value = +params.get("max_price") || 500;

  const [values, setValues] = useState([min_value, max_value]);
  const [inputValues, setInputValues] = useState([min_value, max_value]);
  const handleSliderChange = (newValues) => {
    if (newValues[0] < newValues[1]) {
      setValues(newValues);
      setInputValues(newValues);
    }
  };

  // const triggerDebounce = useDebounce(500, () => {
  //   setPropertyToUrl("min_price", values[0]);
  //   setPropertyToUrl("max_price", values[1]);
  // });
  const fillerStyle = {
    left: `${(values[0] / 500) * 100}%`,
    width: `${((values[1] - values[0]) / 500) * 100}%`,
  };
  const handleMinInputChange = (e) => {
    const newMin = e.target.value === "" ? "" : Number(e.target.value);
    setInputValues([newMin, inputValues[1]]);

    if (newMin !== "" && newMin >= 0 && newMin < values[1]) {
      setValues([newMin, values[1]]);
    }
  };

  const handleMaxInputChange = (e) => {
    const newMax = e.target.value === "" ? "" : Number(e.target.value);
    setInputValues([inputValues[0], newMax]);

    if (newMax !== "" && newMax <= 500 && newMax > values[0]) {
      setValues([values[0], newMax]);
    }
  };
  const setPriceToUrl = () => {
    setPropertyToUrl("min_price", values[0]);
    setPropertyToUrl("max_price", values[1]);
  };
  const handleBlur = () => {
    setInputValues(values);
  };

  useEffect(() => {
    if (values[0] && values[1]) {
    }
  }, [values[0], values[1]]);
  const [activeFilter, setActiveFilter] = useState(null);

  const handleFilter = (filterName) => {
    setActiveFilter(filterName);
  };

  const closeFilter = () => {
    setActiveFilter(null);
  };
  const deleteFilter = () => {
    setActiveFilter(null);
  };
  const [activeFilterTop, setActiveFilterTop] = useState(null);
  const filterButton = () => {
    setActiveFilterTop(true);
  };
  const closeFilterTop = () => {
    setActiveFilterTop(null);
  };

  return (
    <div className="xl-3 lg-3 md-3 sm-12">
      <div className={false ? "filterTop active" : "filterTop"}>
        <ArrowLeft className="closeFilter" onClick={closeFilterTop} />
        <span>{t["buttons.filter"]}</span>
        {/* <Delete /> */}
        <div className="filterTopCategory">
          <div onClick={() => handleFilter("categories")}>
            <p> {t["sidebar.categories"]} </p> <ArrowRight />
          </div>
          <div onClick={() => handleFilter("price_range")}>
            <p> {t["table.header.value"]} </p> <ArrowRight />
          </div>
          <div onClick={() => handleFilter("brands")}>
            <p> {t["sidebar.brands"]} </p> <ArrowRight />
          </div>
          <div onClick={() => handleFilter("groups")}>
            <p> {t["title.groups"]} </p> <ArrowRight />
          </div>
          <div onClick={() => handleFilter("authors")}>
            <p> {t["title.authors"]} </p> <ArrowRight />
          </div>
          <div onClick={() => handleFilter("notes")}>
            <p> {t["title.notes"]} </p> <ArrowRight />
          </div>
          <div onClick={() => handleFilter("season")}>
            <p> {t["title.choose_parfume_season"]} </p> <ArrowRight />
          </div>
          <div onClick={() => handleFilter("time_of_day")}>
            <p> {t["title.choose_perfume_time"]} </p> <ArrowRight />
          </div>
        </div>
      </div>
      <div
        className={
          activeFilter === "categories" ? "filterCard active" : "filterCard"
        }
      >
        <ArrowLeft className="closeFilter" onClick={closeFilter} />
        <Delete className="deleteFilter" onClick={deleteFilter} />
        <div className="filterCardTop">
          <span>{t["sidebar.categories"]} </span>
        </div>
        <div className="filterCardBody">
          {filter.genders.map((item) => (
            <div className="categoryFilter" key={item.id}>
              <input
                type="checkbox"
                onChange={() => {
                  setPropertyToUrlWithArray("genders[]", item.alias);
                }}
                checked={params.getAll("genders[]").includes(item.alias)}
              />
              <span>
                {item.title}
                {/* ({item.count}) */}
              </span>
            </div>
          ))}
        </div>
        <div className="blackButton" onClick={closeFilter}>
          {t["buttons.back_to_shop"]}
        </div>
      </div>
      <div
        className={
          activeFilter === "price_range" ? "filterCard active" : "filterCard"
        }
      >
        <ArrowLeft className="closeFilter" onClick={closeFilter} />
        <Delete className="deleteFilter" onClick={deleteFilter} />

        <div className="filterCardTop">
          <span>{t["table.header.value"]}</span>
        </div>
        <div className="filterCardBody filterPrice">
          <div className="priceFilter">
            <div>
              <input
                type="number"
                value={inputValues[0]}
                onChange={handleMinInputChange}
                onBlur={handleBlur}
                min="0"
                max={values[1] - 1}
              />
              ₼
            </div>
            <div>
              <input
                type="number"
                value={inputValues[1]}
                onChange={handleMaxInputChange}
                onBlur={handleBlur}
                min={values[0] + 1}
                max="500"
              />
              ₼
            </div>
            <button type="button" onClick={setPriceToUrl}>
              <Search />
            </button>
          </div>
          <div className="sliderPrice">
            <Slider
              value={values}
              onChange={handleSliderChange}
              minValue={0}
              maxValue={500}
              step={50}
              className="priceRange"
            />
            <div className="sliderTrack">
              <div className="sliderFiller" style={fillerStyle}></div>
            </div>
          </div>
        </div>
        <div className="blackButton" onClick={closeFilter}>
          {t["buttons.show"]}
        </div>
      </div>
      <div
        className={
          activeFilter === "brands" ? "filterCard active" : "filterCard"
        }
      >
        <ArrowLeft className="closeFilter" onClick={closeFilter} />
        <Delete className="deleteFilter" onClick={deleteFilter} />

        <div className="filterCardTop">
          <span>{t["sidebar.brands"]}</span>
          <div className="inputFilter">
            <input
              type="text"
              placeholder={t["input_brandSearch_placeholder"]}
              value={brandQuery}
              onChange={(e) => setBrandQuery(e.target.value)}
              className="border p-2 rounded w-full"
            />
            <Search />
          </div>
        </div>
        <div className="filterCardBody brandFilterBody">
          {filter.brands.length > 0 ? (
            filter.brands.filter((item) =>
              item.title.toLowerCase().includes(brandQuery.toLowerCase())
            ).length > 0 ? (
              filter.brands
                .filter((item) =>
                  item.title.toLowerCase().includes(brandQuery.toLowerCase())
                )
                .map((item) => (
                  <div className="checkboxFilter" key={item.id}>
                    <input
                      onChange={() =>
                        setPropertyToUrlWithArray("brands[]", item.alias)
                      }
                      checked={params.getAll("brands[]").includes(item.alias)}
                      type="checkbox"
                    />
                    <div>
                      <span></span>
                      <p>
                        {item.title}
                        {/* ({item.count}) */}
                      </p>
                    </div>
                  </div>
                ))
            ) : (
              <span className="notFoundSpan">{t["brand.notfound"]}</span>
            )
          ) : (
            <span className="notFoundSpan">{t["brand.notfound"]}</span>
          )}
        </div>
        <div className="blackButton" onClick={closeFilter}>
          {t["buttons.show"]}
        </div>
      </div>
      <div
        className={
          activeFilter === "groups" ? "filterCard active" : "filterCard"
        }
      >
        <ArrowLeft className="closeFilter" onClick={closeFilter} />
        <Delete className="deleteFilter" onClick={deleteFilter} />

        <div className="filterCardTop">
          <span>{t["title.groups"]}</span>
          <div className="inputFilter">
            <input
              type="text"
              placeholder={t["input_groupSearch_placeholder"]}
              value={groupQuery}
              onChange={(e) => setGroupQuery(e.target.value)}
              className="border p-2 rounded w-full"
            />
            <Search />
          </div>
        </div>
        <div className="filterCardBody brandFilterBody">
          {filter.groups.length > 0 ? (
            filter.groups.filter((item) =>
              item.title.toLowerCase().includes(groupQuery.toLowerCase())
            ).length > 0 ? (
              filter.groups
                .filter((item) =>
                  item.title.toLowerCase().includes(groupQuery.toLowerCase())
                )
                .map((item) => (
                  <div className="checkboxFilter" key={item.id}>
                    <input
                      onChange={() => {
                        setPropertyToUrlWithArray("groups[]", item.alias);
                      }}
                      checked={params.getAll("groups[]").includes(item.alias)}
                      type="checkbox"
                    />
                    <div>
                      <span></span>
                      <p>
                        {item.title}
                        {/* ({item.count}) */}
                      </p>
                    </div>
                  </div>
                ))
            ) : (
              <span className="notFoundSpan">{t["group.notfound"]}</span>
            )
          ) : (
            <span className="notFoundSpan">{t["group.notfound"]}</span>
          )}
        </div>
        <div className="blackButton" onClick={closeFilter}>
          {t["buttons.show"]}
        </div>
      </div>
      <div
        className={
          activeFilter === "authors" ? "filterCard active" : "filterCard"
        }
      >
        <ArrowLeft className="closeFilter" onClick={closeFilter} />
        <Delete className="deleteFilter" onClick={deleteFilter} />

        <div className="filterCardTop">
          <span>{t["title.authors"]}</span>
          <div className="inputFilter">
            <input
              type="text"
              placeholder={t["input.search"]}
              value={authorQuery}
              onChange={(e) => setAuthorQuery(e.target.value)}
              className="border p-2 rounded w-full"
            />
            <Search />
          </div>
        </div>
        <div className="filterCardBody brandFilterBody">
          {filter.authors.length > 0 ? (
            filter.authors.filter((item) =>
              item.title.toLowerCase().includes(authorQuery.toLowerCase())
            ).length > 0 ? (
              filter.authors
                .filter((item) =>
                  item.title.toLowerCase().includes(authorQuery.toLowerCase())
                )
                .map((item) => (
                  <div className="checkboxFilter" key={item.id}>
                    <input
                      onChange={() => {
                        setPropertyToUrlWithArray("authors[]", item.alias);
                      }}
                      checked={params.getAll("authors[]").includes(item.alias)}
                      type="checkbox"
                    />
                    <div>
                      <span></span>
                      <p>
                        {item.title}
                        {/* ({item.count}) */}
                      </p>
                    </div>
                  </div>
                ))
            ) : (
              <span className="notFoundSpan">{t["authors.notfound"]}</span>
            )
          ) : (
            <span className="notFoundSpan">{t["authors.notfound"]}</span>
          )}
        </div>
        <div className="blackButton" onClick={closeFilter}>
          {t["buttons.show"]}
        </div>
      </div>
      <div
        className={
          activeFilter === "notes" ? "filterCard active" : "filterCard"
        }
      >
        <ArrowLeft className="closeFilter" onClick={closeFilter} />
        <Delete className="deleteFilter" onClick={deleteFilter} />

        <div className="filterCardTop">
          <span>{t["title.notes"]} </span>
          <div className="inputFilter">
            <input
              type="text"
              placeholder={t["input.search"]}
              value={noteQuery}
              onChange={(e) => setNoteQuery(e.target.value)}
              className="border p-2 rounded w-full"
            />
            <Search />
          </div>
        </div>
        <div className="filterCardBody brandFilterBody">
          {filter.notes.length > 0 ? (
            filter.notes.filter((item) =>
              item.title.toLowerCase().includes(noteQuery.toLowerCase())
            ).length > 0 ? (
              filter.notes
                .filter((item) =>
                  item.title.toLowerCase().includes(noteQuery.toLowerCase())
                )
                .map((item) => (
                  <div className="checkboxFilter" key={item.id}>
                    <input
                      onChange={() => {
                        setPropertyToUrlWithArray("notes[]", item.alias);
                      }}
                      checked={params.getAll("notes[]").includes(item.alias)}
                      type="checkbox"
                    />
                    <div>
                      <span></span>
                      <p>
                        {item.title}
                        {/* ({item.count}) */}
                      </p>
                    </div>
                  </div>
                ))
            ) : (
              <span className="notFoundSpan">{t["note.notfound"]}</span>
            )
          ) : (
            <span className="notFoundSpan">{t["note.notfound"]}</span>
          )}
        </div>
        <div className="blackButton" onClick={closeFilter}>
          {t["buttons.show"]}
        </div>
      </div>
      <div
        className={
          activeFilter === "season" ? "filterCard active" : "filterCard"
        }
      >
        <ArrowLeft className="closeFilter" onClick={closeFilter} />
        <Delete className="deleteFilter" onClick={deleteFilter} />

        <div className="filterCardTop">
          <span>{t["title.choose_parfume_season"]} </span>
        </div>
        <div className="filterCardBody seasonFilter">
          <div className="seasonFilterCard">
            <input
              type="radio"
              onChange={() => {
                setPropertyToUrl("season", "spring-summer");
              }}
              checked={params.get("season") === "spring-summer"}
              name="season"
            />
            <div>
              <Summer />
              <p>{t["filters.genders.spring_summer"]}</p>
              <span></span>
            </div>
          </div>
          <div className="seasonFilterCard">
            <input
              type="radio"
              onChange={() => {
                setPropertyToUrl("season", "winter-fall");
              }}
              checked={params.get("season") === "winter-fall"}
              name="season"
            />
            <div>
              <Snow />
              <p>{t["filters.seasons.winter_fall"]}</p>
              <span></span>
            </div>
          </div>
        </div>
        <div className="blackButton" onClick={closeFilter}>
          {t["buttons.show"]}
        </div>
      </div>
      <div
        className={
          activeFilter === "time_of_day" ? "filterCard active" : "filterCard"
        }
      >
        <ArrowLeft className="closeFilter" onClick={closeFilter} />
        <Delete className="deleteFilter" onClick={deleteFilter} />

        <div className="filterCardTop">
          <span>{t["title.choose_perfume_time"]}</span>
        </div>
        <div className="filterCardBody seasonFilter">
          <div className="seasonFilterCard">
            <input
              onChange={() => {
                setPropertyToUrl("part_of_day", "day");
              }}
              checked={params.get("part_of_day") === "day"}
              type="radio"
              name="day"
            />
            <div>
              <Sun />
              <p>{t["filters.part_of_day.day"]}</p>
              <span></span>
            </div>
          </div>
          <div className="seasonFilterCard">
            <input
              type="radio"
              onChange={() => {
                setPropertyToUrl("part_of_day", "night");
              }}
              checked={params.get("part_of_day") === "night"}
              name="day"
            />
            <div>
              <Moon />
              <p>{t["title.night_parfume"]}</p>
              <span></span>
            </div>
          </div>
        </div>
        <div className="blackButton" onClick={closeFilter}>
          {t["buttons.show"]}
        </div>
      </div>
    </div>
  );
};

export default Filter;
